/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */
export { platformBrowserDynamicTesting, BrowserDynamicTestingModule, ɵDOMTestComponentRenderer, ɵplatformCoreDynamicTesting } from './public_api';
export { COMPILER_PROVIDERS as ɵa, TestingCompilerFactoryImpl as ɵb } from './src/compiler_factory';
//# sourceMappingURL=testing.js.map